module.exports = __webpack_public_path__ + "static/media/python.5357551a.svg";